// Single source of truth for the bidding-wizard URL scheme. All four
// steps live under one prefix `/order/*` so nginx has a single location
// to route to the SPA entrypoint, and adding a new step is a frontend-
// only change (no nginx edit).
//
// `WIZARD_BASE` is also a valid step on its own ("/order") — the React
// router serves OrderForm when the path is exactly the base.
export const WIZARD_BASE = '/order';

export const PATH_ORDER   = WIZARD_BASE;
export const PATH_PAYMENT = `${WIZARD_BASE}/payment`;
export const PATH_BIDDING = `${WIZARD_BASE}/bidding`;
export const PATH_REOPEN  = `${WIZARD_BASE}/reopen`;
